import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgency text-white py-3 px-4 text-center shadow-md" data-id="element-161">
      <p className="font-sans font-bold text-sm md:text-base tracking-wide flex items-center justify-center gap-2 flex-wrap" data-id="element-162">
        <span className="relative inline-flex items-center justify-center w-3 h-3 flex-shrink-0" data-id="element-163">
          <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping" data-id="element-164"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-165"></span>
        </span>
        <span data-id="element-166">
          ⚡ PRIX DE LANCEMENT — Il reste{' '}
          <span className="underline decoration-2 underline-offset-2" data-id="element-167">
            31 accès
          </span>{' '}
          à 9,97$ — Expire dans 3 jours
        </span>
      </p>
    </div>;
}